import { render } from "./BuekOrgenIframe.vue?vue&type=template&id=e72c9d1c&ts=true"
import script from "./BuekOrgenIframe.ts?vue&type=script&lang=ts&external"
export * from "./BuekOrgenIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__